<template>
    <div class="loader__container" id="pageloader">

        <div class="wrapper">

            <div class="left"></div>
            <div class="right"></div>

            <div class="logo">

                <div class="circle__wrapper">
                    <div class="half__circle"></div>
                </div>


                <div class="lines__row">

                    <div class="line__1"></div>

                    <div class="line__2"></div>

                    <div class="line__3"></div>

                </div>

                <div class="end__row">
                    <div class="fill"></div>
                    <div class="end"></div>
                </div>

            </div>

        </div>

        

    </div>
</template>
<script>
export default {
    data(){
        return {
            text: "Vue3 component."
        }
    },
    created() {
        if(window.innerWidth > 836) {
            document.body.classList.add('noScrollLoader');
        }
    },
    mounted(){
        window.addEventListener("load", (event) => {
            document.getElementById('pageloader').classList.add('hiding');

            setTimeout(() => {

                if(window.innerWidth > 836) {
                    document.body.classList.remove('noScrollLoader');
                }
                
                document.getElementById('pageloader').classList.add('hidden');

             }, 1000);
        });
    }
}
</script>
<style lang="scss" scoped>

    .loader__container{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1000000;

        transition: all 1s ease;

        &.hiding{
            opacity: 0;
        }

        &.hidden{
            display: none;
        }
    }

    .loader__container.hiding .wrapper{
        .left{
            transform: translateX(-100%);
        }

        .right{
            transform: translateX(100%);
        }
    }

    .wrapper{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;

        .left, .right{
            background: #000;
            width: 50%;
            transition: all 1s ease;
            height: 100vh;
        }

        .left{
            -webkit-perspective-origin: left;
            perspective-origin: left;
        }

        .right{
            -webkit-perspective-origin: right;
            perspective-origin: right;
        }

        .logo{
            position: absolute;
            top: 50%; right: 50%;
            transform: translate(50%,-50%);

            display: flex;
            flex-direction: column;
            width: 100px;
            height: 140px;

            .circle__wrapper{
                width: 100%;
                height: 50px;
                overflow-y: hidden;

                .half__circle{
                    background-color: transparent;
                    height: 100px;
                    border-radius:50px;
                    // width:100px;

                    overflow: hidden;

                    border: 15px solid #fff;
                    transition: all .3s ease;
                }
            }

            .lines__row{
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .line__1, .line__2, .line__3{
                    // background: #fff;
                    background-image: transparent;
                    transition: all .3s ease;

                    width: 15px;
                    height: 80px;
                }
            }


            .end__row{
                display: flex;
                flex-direction: row;

                .fill, .end{
                    // background: #fff;
                    background: transparent;
                    transition: all .3s ease;
                }

                .fill{
                    width: 57.5px;
                    height: 15px;
                }

                .end{
                    width: 15px;
                    height: 15px;
                    margin-left: auto;
                    margin-right: 0;
                }
            }

            .lines__row .line__1, .lines__row .line__2, .lines__row .line__3, .end__row .fill, .end__row .end{
                animation: colorChange 1.9s;
                animation-iteration-count: infinite;
                animation-timing-function: ease;
            }
            
            .circle__wrapper .half__circle{
                animation: borderColorChange 1.9s;
                animation-iteration-count: infinite;
                animation-timing-function: ease;
            }

        }

    }


    @keyframes colorChange {
        0% {
            background: transparent;
        }

        50%{
            background: #fff;
        }

        100%{
            background: transparent;
        }
    }

    @keyframes borderColorChange {
        0% {
            border-color: transparent;
        }

        50%{
            border-color: #fff;
        }

        100%{
            border-color: transparent;
        }
    }

</style>